import { COLORS } from '@btime/constants'
import { prop } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLinkTreeFormActions } from '../_form/LinkTreeFormHandler'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import Input from '../../../../components/form/Input'
import IconPicker from '../../../../components/form/IconPicker'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { HorizontalLine, VerticalLine } from '../../../../components/shapes/Line'
import Tag, { Tags } from '../../../../packages/kiti/components/presentation/Tag'

const LinkTreeItemHistory = ({ item, isLast, isTheOnlyOne, index }) => {
  const { t } = useTranslation('editLinkTreeItems')
  const { handleChange } = useLinkTreeFormActions()

  const questions = item?.configuration?.filter?.questions
  const statuses = item?.configuration?.filter?.statuses
  const fieldName = item?.configuration?.sort?.field?.name
  const typeName = item?.configuration?.sort?.type?.name

  React.useEffect(() => {
    if (!isTheOnlyOne) handleChange(index, 'isDefault', false)
  }, [isTheOnlyOne, handleChange, index])

  return (
    <FlexGrid direction="column" justify="space-between" align="center">
      <Separator weight={3} />

      <FlexCol flex={1} width="100%">
        <FlexGrid direction="row">
          <FlexCol flex={3}>
            <IconPicker value={item.icon} size="1.5rem" onChange={handleChange(index, 'icon')} hideOn />
          </FlexCol>
          <VerticalLine lineColor={COLORS.light2} fullHeight />

          <FlexCol flex={4}>
            <Input
              value={item.label}
              onStopTyping={handleChange(index, 'label')}
              placeholder={t('titlePlaceholder')}
              bgColor={!item.enabled && COLORS.dark3}
            />
          </FlexCol>
        </FlexGrid>
        <Separator weight={6} />

        <HorizontalLine thin lineColor={COLORS.light2} />
      </FlexCol>

      <Separator weight={6} />

      <FlexCol flex={1} width="100%">
        <FlexGrid direction="row">
          {!!questions && questions?.length !== 0 && (
            <FlexCol flex={1}>
              <SmallText>{t('checklist')}: </SmallText>
              <Separator weight={2} />
              <Tags values={questions.map(prop('name'))} color={COLORS.dark3} medium />
            </FlexCol>
          )}
          {!!statuses && statuses?.length !== 0 && (
            <FlexCol flex={1}>
              <SmallText>{t('status')}: </SmallText>
              <Separator weight={2} />
              <Tags values={statuses.map(prop('label'))} color={COLORS.dark3} medium />
            </FlexCol>
          )}
          {!!fieldName && typeName && (
            <FlexCol flex={1}>
              <Text>
                <SmallText>{t('sortBy')}: </SmallText>
                <Separator weight={2} />
                <Tag label={t('sortByFormat', { field: fieldName, type: typeName })} color={COLORS.dark3} medium />
              </Text>
            </FlexCol>
          )}
        </FlexGrid>
      </FlexCol>

      <Separator weight={3} />
    </FlexGrid>
  )
}

export default LinkTreeItemHistory
